import { TYPES, CallbackRequestActions } from 'store/modules/callback-request/actions';
import { ISubmitData } from 'types';

interface ICallbackRequestReducerState {
  isLoading: boolean;
  isSubmitted: boolean;
  success?: boolean;
  error?: any;
  data?: ISubmitData;
  hasSubmittedSilent: boolean;
  hasSubmittedContactDetailsSilent: boolean;
}

const initialState: ICallbackRequestReducerState = {
  isLoading: false,
  isSubmitted: false,
  hasSubmittedSilent: false,
  hasSubmittedContactDetailsSilent: false,
};

export const callbackRequestReducer = (state = initialState, action: CallbackRequestActions) => {
  switch (action.type) {
    case TYPES.SUBMIT:
      return {
        ...state,
        isLoading: true,
      };

    case TYPES.SUBMIT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSubmitted: true,
        success: true,
      };

    case TYPES.SUBMIT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };

    case TYPES.SILENT_SUBMIT:
      return {
        ...state,
      };

    case TYPES.SILENT_SUBMIT_SUCCESS:
      return {
        ...state,
        hasSubmittedSilent: true,
      };

    case TYPES.SILENT_SUBMIT_FAIL:
      return {
        ...state,
      };

    case TYPES.SILENT_CONTACT_DETAILS_SUBMIT:
      return {
        ...state,
      };

    case TYPES.SILENT_CONTACT_DETAILS_SUBMIT_SUCCESS:
      return {
        ...state,
        hasSubmittedContactDetailsSilent: true,
      };

    case TYPES.SILENT_CONTACT_DETAILS_SUBMIT_FAIL:
      return {
        ...state,
      };

    case TYPES.RESET:
      return initialState;

    default:
      return state;
  }
};
